import { Timestamp } from "firebase/firestore";
import moment from "moment";
import {
  startOfToday,
  endOfToday,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  subWeeks,
  subMonths,
  subYears,
  setDate,
} from "date-fns";

export const formatTimestamp = (timestamp, withTime = true) => {
  if (!timestamp) return "N/A";

  let date;

  // Check if Firestore Timestamp (has toDate())
  if (timestamp.toDate) {
    date = timestamp.toDate();
  } else if (timestamp instanceof Date) {
    date = timestamp;
  } else if (typeof timestamp === "number" || typeof timestamp === "string") {
    date = new Date(timestamp);
  } else {
    return "Invalid timestamp";
  }
  
  if(!withTime){
    return moment(date).format("MMMM Do YYYY")
  }

  return moment(date).format("MMMM Do YYYY, h:mm:ss A");
};

export const timeAgo = (timestamp) => {
  if (!timestamp) return "Some time ago";

  let date;
  if (timestamp.toDate) {
    date = timestamp.toDate();
  } else if (timestamp instanceof Date) {
    date = timestamp;
  } else if (typeof timestamp === "number" || typeof timestamp === "string") {
    date = new Date(timestamp);
  } else {
    return "Invalid time";
  }

  return moment(date).fromNow(); // e.g., "5 minutes ago"
};

export const getDateRange = (filter) => {
  const now = new Date();
console.log(filter)
  const ranges = {
    today: {
      start: startOfToday(),
      end: endOfToday(),
    },
    thisWeek: {
      start: startOfWeek(now),
      end: endOfWeek(now),
    },
    aWeekAgo: {
      start: startOfWeek(subWeeks(now, 1)),
      end: endOfWeek(subWeeks(now, 1)),
    },
    threeWeeksAgo: {
      start: startOfWeek(subWeeks(now, 3)),
      end: endOfWeek(subWeeks(now, 1)), // End of week 1 week ago
    },
    lastMonth: {
      start: startOfMonth(subMonths(now, 1)),
      end: endOfMonth(subMonths(now, 1)),
    },
    threeMonthsAgo: {
      start: startOfMonth(subMonths(now, 3)),
      end: endOfMonth(subMonths(now, 1)), // End of month 1 month ago
    },
    thisYear: {
      start: startOfYear(now),
      end: endOfYear(now),
    },
    lastYear: {
      start: startOfYear(subYears(now, 1)),
      end: endOfYear(subYears(now, 1)),
    },
  };

  if (!ranges[filter]) {
    throw new Error(`Invalid date filter: ${filter}`);
  }

  return {
    start: Timestamp.fromDate(ranges[filter].start),
    end: Timestamp.fromDate(ranges[filter].end),
  };
};
